import styled from 'styled-components';

export const ToggleWrap = styled.div`
  background: white;
  border-radius: 0.4rem;
  border: 1px solid #e5edf6;
  margin: 1.5rem;
`;
export const PriceTxtBold = styled.span`
  font-size: 1.4rem;
  color: black;
  font-weight: bold;
  padding-right: 2rem;
`;
export const TotalPriceRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e5edf6;
  ${PriceTxtBold} {
    padding-right: 0;
  }
`;
export const SeatNumber = styled.p`
  font-size: 1.2rem;
  color: #898b91;
  padding-top: 0.3rem;
`;
export const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
`;

export const PriceTxt = styled(PriceTxtBold)`
  font-weight: normal;
`;
export const DetailedFairWrap = styled.div`
  max-height: 0;
  overflow: hidden;
`;
export const ToggleHeaderLabel = styled.label(
  props => `
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 1.5rem 1rem;
        cursor: pointer;
        position: relative;
        &::after {
            content: '\\276F';
            text-align: center;
            transform:rotate(-90deg);
            -webkit-transition: all .35s;
            transition: all .35s;
            color: #898b91;
            font-size: 1.2rem;
            position: absolute;
            right: 0;
            padding: 0.3rem 1rem;
        }
        
    `,
);
export const ToggleHeaderInput = styled.input`
  position: absolute;
  opacity: 0;
  z-index: -1;
  &:checked + ${ToggleHeaderLabel}::after {
    transform: rotate(90deg);
  }
  &:checked ~ ${DetailedFairWrap} {
    max-height: 100vh;
    padding: 1rem;
    border-top: 1px solid #e5edf6;
  }
`;
export const FormLabelTxt = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const FareWrapContent = styled.section`
  padding-bottom: 1rem;
  border-top: 1px solid #e5edf6;
`;
export const NotSignedInTag = styled.section`
  border-radius: 2px;
  background-color: #e9f6ea;
  padding: 1rem;
`;
export const SignInTxt = styled.span`
  font-size: 1.2rem;
  color: #2276e3;
`;
export const SignInOfferTag = styled.div`
  background: #fef8e5;
  padding: 0.6rem 1rem;
  color: #2276e3;
  font-size: 1.4rem;
  width: 90%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor:pointer;
  .arrowRight {
    width: 0;
    height: 0;
    position: absolute;
    right: -1.5rem;
    top: 0;
    border-top: 1.85rem solid transparent;
    border-left: 1.5rem solid #fef8e5;
    border-bottom: 1.85rem solid transparent;
  }
`;
